import { Injectable } from '@angular/core';
import { IGetBookingsAirResponse } from "libraries/service/resources/booking/interfaces/IGetBookings";


@Injectable({
    providedIn: 'root',
})
/**
 * used to store and retreive CB Air response, in order to use it if GB is in Error
 */
export class BookingCbCacheService {

    private readonly cache: Map<string, IGetBookingsAirResponse> = new Map();

    public storeCreateBookingResponse(syscode: string, booking: IGetBookingsAirResponse): void {
        this.cache.set(syscode, booking);
    }

    public getCreateBookingResponse(syscode: string): IGetBookingsAirResponse {
        // #36186 : ensure if special chars in url, it will be decoded
        return this.cache.get(decodeURI(syscode));
    }

    public hasCreateBookingResponse(syscode: string): boolean {
        // #36186 : ensure if special chars in url, it will be decoded
        return this.cache.has(decodeURI(syscode));
    }

    public removeCreateBookingResponse(syscode: string): void {
        this.cache.delete(syscode);
    }
    public clearCache(): void {
        this.cache.clear();
    }
}
